module.exports = __webpack_public_path__ + "img/rulesBg.3e8e1ce.png";